import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type { WebsiteType } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type FindWebsiteTypeFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/WebsiteTypeFilter/WebsiteTypeFilter";

import { MAX_CHIPS_GROUP_AMOUNT } from "../../../constants";

import { TRANSLATION_PREFIX } from "./const";

const WebsiteTypeFilterResult = ({
    value,
    isExpanded,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindWebsiteTypeFilter>): ReactElement | null => {
    const handleRemove = (id: WebsiteType) => {
        const updatedValues = value?.types?.filter((v) => v !== id);
        const newValue = { ...value, types: updatedValues };

        onFilterValueRemove?.(newValue);
        onFilterUpdate(newValue);
    };

    if (!value?.types?.length) {
        return null;
    }

    const chipItems: ChipItem[] = value.types.map((item: string) => {
        return {
            id: item,
            text: translate(`${TRANSLATION_PREFIX}.${item}`),
            chipStatus: onGetLifecycleStatus?.(item),
        };
    });

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemove}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default WebsiteTypeFilterResult;
